// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-field-select[data-v-0282c658]{display:flex;flex-direction:column;gap:4px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
